<template>
  <div>
    <transition name="fade">
      <MenssageAlert :messages="messages" />
    </transition>
    <div class="dataTable__buttonLink text-right mb-2" style="position: relative">
      <CButton class="px-4 py-2" color="primary" tag="button" @click="exportPopup = true">
        {{ $t('transaction.history.button.export') }}
        <CIcon name="arrowExport" size="custom-size" :height="18" class="ml-2" viewBox="0 0 32 32" />
      </CButton>
      <transition name="fade" v-if="exportPopup">
        <div class="dataTable__popUp popUp" style="right: 0; left: unset" @click.stop.stop>
          <div class="popUp__body shadow-sm">
            <ChooseExport v-if="!loadingExport" @confirm="exportRecods($event)" @cancel="closePopupExport" />
            <LoadingSpinner v-else size="sm" />
            <div class="blocker" @click="closePopupExport"></div>
          </div>
        </div>
      </transition>
    </div>

    <CRow class="mb-3">
      <CCol md="3">
        <form @submit.prevent class="search-padding">
          <CInput
            type="search"
            v-model="searched"
            @input="updateSearchFilter"
            :placeholder="$t('transational.logs.search.placeholder')"
            addInputClasses="pl-5"
            class="iconSearchPlaceholder-table text-left newInput"
          >
          </CInput>
        </form>
      </CCol>
      <CCol md="2">
        <label class="mb-0 mr-3"> {{ $t('transational.logs.originType') }}: </label>
        <v-select
          class="no-close newInput"
          :options="originTypeOptions"
          v-model="originTypeSelected"
          @option:selected="udpateOriginTypeFilter"
          placeholder="Select"
        >
        </v-select>
      </CCol>
      <CCol md="2">
        <label class="mb-0 mr-3"> {{ $t('transational.logs.country') }}: </label>
        <v-select
          class="no-close newInput"
          v-model="countryId"
          :options="optionsCountriesNames"
          :placeholder="$t('transational.logs.country')"
          @option:selected="updateTableCountry"
        >
          <template #selected-option="{ value, flag }">
            <img :src="flag" alt width="25" class="mr-3" />
            <span v-if="value" :key="value">{{ value }}</span>
            <span v-else>
              {{ $t('transational.logs.filters.all') }}
            </span>
          </template>
          <template v-slot:option="option">
            <img :src="option.flag" width="20" height="auto" class="mr-2" />
            <span>{{ option.label }}</span>
          </template>
        </v-select>
      </CCol>
      <CCol md="2">
        <label class="mb-0 mr-3"> {{ $t('transational.logs.filterBy') }}: </label>
        <v-select
          class="no-close newInput"
          :options="filterByOptions"
          v-model="filterByOptionsSelected"
          @option:selected="updateTableFilterBy"
          placeholder="Select"
        >
        </v-select>
      </CCol>
      <CCol md="3">
        <form @submit.prevent class="">
          <label for="Select period" class="mb-0 mr-3">{{ $t('transational.logs.selectPeriod') }}: </label>
          <v-date-picker
            mode="range"
            color="purple"
            timezone="UTC"
            is-range
            :value="range"
            :max-date="maxDate"
            :min-date="minDate"
            addInputClasses="newInput"
            @input="updateTablePeriod"
          >
            <template v-slot="{ inputValue, inputEvents, showPopover, hidePopover }">
              <CInput
                :value="rangeFormatted"
                class="dateInputCustom newInput px-0 text-left inputAppendCustom inputAppendCustom--transparent"
                add-input-classes="pr-0"
                v-on="inputEvents"
                readonly
                style="min-width: 260px; background-color: white"
                @mouseover="showPopover"
                @mouseleave="hidePopover"
              >
                <template #append-content>
                  <span @click="clearRange" class="pr-none">
                    <CIcon
                      v-if="inputValue"
                      class="btn-value mt-2 text-center"
                      name="cilXCircle"
                      size="custom-size"
                      :height="23"
                      viewBox="0 0 32 32"
                    />
                  </span>
                </template>
              </CInput>
            </template>
          </v-date-picker>
        </form>
      </CCol>
    </CRow>

    <SenditTable
      :headers="headers"
      :registers="registers"
      :loading="loading"
      :itemsPerPage="itemsPerPage"
      :currentPage="currentPage"
      :totalPages="totalPages"
      :pagination="registers.length > 0"
      @updatePage="atualizandoPage"
      :noData="!hasFilter && !hasRegister"
    >
      <template #footer-left>
        <div class="d-flex flex-column justify-content-center" v-if="registers.length > 0">
          <p class="m-0">
            <CIcon name="recover" size="custom-size" class="mr-2" :height="25" viewBox="0 0 32 32" />
            {{ $t('transational.logs.table.text.registers') }}
          </p>
        </div>
      </template>

      <template #originType="{ item }">
        <td>{{ $t(originTypeHandler(item.originType)) }}</td>
      </template>

      <template #sent="{ item }">
        <td>{{ handleDate(item.sent) }}</td>
      </template>

      <template #countryId="{ item }">
        <td>
          <img :src="getFlag(item.countryId).flag" width="25" height="auto" class="mr-2" />
          {{ getFlag(item.countryId).label }}
        </td>
      </template>

      <template #status="{ item }">
        <td>
          <!-- <CButton
          color="transparent"
          v-c-tooltip.hover.click="{
            content: 'Message has been sent',
            placement: 'bottom',
          }"
          v-if="item.status == 3"
        >
          <CIcon
            name="notificationAlert"
            class="m-0 p-0"
            :class="handleStatus(item.status).status"
            size="custom-size"
            :height="14"
            viewBox="0 0 32 32"
          />
        </CButton> -->

          <CIcon
            v-if="item.status == 3"
            name="notificationAlert"
            class="m-0 p-0"
            size="custom-size"
            viewBox="0 0 32 32"
            :class="handleStatus(item.status).status"
            :height="14"
          />
          <span :class="handleStatus(item.status).status" class="text-uppercase font-weight-bold font-sm">
            {{ handleStatus(item.status).label }}
          </span>
        </td>
      </template>

      <template #deliveryReportUpdateDateTime="{ item }">
        <td>{{ handleDate(item.deliveryReportUpdateDateTime) }}</td>
      </template>
    </SenditTable>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import SenditTable from '@/components/table/SenditTable.vue'
import MenssageAlert from '@/components/MenssageAlert'
import { dateTimeFormatString, getUserDateFormat } from '@/utils/dateUtil'
import { nameCountries } from '@/utils/countriesUtils.js'
import services from '@/services.js'
import ChooseExport from '@/components/ChooseExport'
import { getFilenameFromContentDisposition } from '@/utils/responseHeaderUtils'
import fileDownload from 'js-file-download'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import { DateTime } from 'luxon'

const TransactionalOriginTypeEnum = {
  1: 'transactional',
  2: 'zapier',
  3: 'quick',
}

const statusSMS = {
  1: 'Delivered',
  2: 'pedding',
  3: 'Not Delivered',
}

export default {
  components: {
    SenditTable,
    vSelect,
    MenssageAlert,
    ChooseExport,
    LoadingSpinner,
  },

  data() {
    return {
      exportPopup: false,
      loadingExport: false,
      registers: [],
      itemsPerPage: 10,
      totalRegisters: null,
      currentPage: 1,
      totalPages: null,
      searched: '',
      loading: false,
      selectedItems: [],
      propsHeaders: [],
      requestOptions: {},
      table: 'sms',
      filters: {
        Page: 1,
        Count: 10,
        // Recipient: null,
        // Status: null,
        // countryCode: null,
        IniDate: null,
        EndDate: null,
      },
      timeout: null,
      filterByOptions: [
        { label: this.$t('transational.logs.filters.all'), key: null },
        { label: this.$t('transational.logs.filters.delivered'), key: 1 },
        { label: this.$t('transational.logs.filters.pending'), key: 2 },
        { label: this.$t('transational.logs.filters.not-delivered'), key: 3 },
      ],
      filterByOptionsSelected: { label: this.$t('transational.logs.filters.all'), key: null },
      originTypeOptions: [
        { label: this.$t('transational.logs.filters.all'), key: null },
        { label: this.$t('transational.logs.transactionStatus.transactional'), key: 1 },
        { label: this.$t('transational.logs.transactionStatus.zapier'), key: 2 },
        { label: this.$t('transational.logs.transactionStatus.quick'), key: 3 },
      ],
      originTypeSelected: { label: this.$t('transational.logs.filters.all'), key: null },
      countryId: null,
      countriesIDs: [],
      range: {
        start: null,
        end: null,
      },
      masks: {
        input: 'YYYY-MM-DD',
      },
      messages: [],
      organizationId: null,
    }
  },

  created() {
    this.organizationId = this.$route.params.organizationId

    this.range = {
      start: DateTime.utc().minus({ days: 7 }).startOf('day').toISO(),
      end: this.maxDate,
    }

    this.filters.IniDate = this.range.start
    this.filters.EndDate = this.range.end
  },

  mounted() {
    this.getData()
    this.getLogsCountries()
  },

  update() {
    this.getData()
  },

  computed: {
    optionsCountriesNames() {
      let result = [{ label: this.$t('transational.logs.filters.all'), key: null }]
      result.push(...nameCountries(this).filter((el) => this.countriesIDs.includes(el.value)))
      return result
    },
    minDate() {
      return DateTime.utc().minus({ days: 90 }).startOf('day').toISO()
    },
    maxDate() {
      return DateTime.utc().endOf('day').toISO()
    },
    contentTable() {
      return statusSMS
    },
    hasRegister() {
      return Boolean(this.registers.length)
    },
    hasFilter() {
      return this.searched != '' || this.filterByOptionsSelected != null || this.range != null
    },
    hasRange() {
      return Boolean(this.range && this.range.start && this.range.end)
    },
    rangeFormatted() {
      if (!this.hasRange) return null

      const userDateTimeFormat = getUserDateFormat(this.$store.state.auth.user.dateTimeFormat)

      const formattedStart = DateTime.fromISO(this.range.start).setZone('UTC').toFormat(userDateTimeFormat)
      const formattedEnd = DateTime.fromISO(this.range.end).setZone('UTC').toFormat(userDateTimeFormat)

      return `${formattedStart} - ${formattedEnd}`
    },
    headers() {
      return [
        {
          key: 'recipient',
          label: this.$t('smsTransaction.table.recipient'),
        },

        {
          key: 'countryId',
          label: this.$t('smsTransaction.table.country'),
        },
        {
          key: 'from',
          label: this.$t('smsTransaction.table.from'),
        },
        {
          key: 'originType',
          label: this.$t('transational.logs.headers.originType'),
        },
        {
          key: 'sms',
          label: this.$t('smsTransaction.table.message'),
        },
        {
          key: 'sent',
          label: this.$t('smsTransaction.table.sentDate'),
        },
        {
          key: 'status',
          label: this.$t('smsTransaction.table.deliveryStatus'),
        },
        {
          key: 'deliveryReportUpdateDateTime',
          label: this.$t('smsTransaction.table.deliveryReportUpdateDateTime'),
        },
        {
          key: 'deliveryReportDescription',
          label: this.$t('smsTransaction.table.deliveryReportDescription'),
        },
        {
          key: 'numberSms',
          label: this.$t('smsTransaction.table.totalSegments'),
        },
      ]
    },
  },

  methods: {
    closePopupExport() {
      this.exportPopup = false
    },

    originTypeHandler(value) {
      return `transational.logs.transactionStatus.${TransactionalOriginTypeEnum[value]}` || ''
    },

    exportRecods(events) {
      this.messages = []
      let organizationId = this.$route.params.organizationId
      let filters = this.filters
      delete filters.Count
      delete filters.Page

      this.loadingExport = true
      filters.format = events.format

      if (events.format == 2) filters.delimiter = events.delimiter

      services
        .getSMSTransactionsExport(organizationId, filters)
        .then((response) => {
          const nameFile = getFilenameFromContentDisposition(response.headers['content-disposition'])

          fileDownload(response.data, nameFile, response.headers['content-type'])
          this.exportPopup = false
        })
        .catch(async ({ response }) => {
          if (response && response.data instanceof Blob) {
            const text = await response.data.text()
            const errorData = JSON.parse(text)

            this.messages.push({
              status: 'danger',
              text: this.$t(`general.errors.${errorData.errorMessage}`),
            })
          }
        })
        .finally(() => {
          this.loadingExport = false
        })
    },

    getLogsCountries() {
      let organizationId = this.$route.params.organizationId
      services.getLogsCountries(organizationId).then((res) => {
        this.countriesIDs = res.data.data
      })
    },
    clearRange() {
      this.range = {
        start: null,
        end: null,
      }

      this.filters.IniDate = this.minDate
      this.filters.EndDate = this.maxDate
    },
    // minDate(daysAgo = 90) {
    //   let date = new Date()
    //   date.setDate(date.getDate() - daysAgo)
    //   return date.toISOString().split('T')[0]
    // },
    getFlag(data) {
      const item = nameCountries(this).filter((item) => item.value.toUpperCase() == data.toUpperCase())
      if (item[0]) {
        return { ...item[0] }
      }
      return ''
    },
    atualizandoPage(currentPage) {
      this.filters.Page = currentPage
      this.getData()
    },
    selecionarLinha(linha) {
      this.selectedItems = linha
    },

    updateTablePeriod(inputValue) {
      if (!inputValue?.start || !inputValue?.end) return

      this.range = {
        start: DateTime.fromJSDate(inputValue.start).setZone('UTC').startOf('day').toISO(),
        end: DateTime.fromJSDate(inputValue.end).setZone('UTC').endOf('day').toISO(),
      }
      this.filters.IniDate = this.range.start
      this.filters.EndDate = this.range.end

      this.filters.Page = 1

      this.getData()
    },

    udpateOriginTypeFilter(value) {
      this.filters.OriginType = value.key
      this.filters.Page = 1

      this.getData()
    },

    updateSearchFilter(value) {
      if (this.timeout) clearTimeout(this.timeout)

      this.timeout = setTimeout(() => {
        this.searched = value
        this.filters.Recipient = value
        this.filters.Page = 1

        this.getData()
      }, 1500)
    },

    updateTableFilterBy(value) {
      this.filterByOptionsSelected = value
      this.filters.Status = value.key
      this.filters.Page = 1

      this.getData()
    },
    updateTableCountry(value) {
      this.countryId = value
      this.filters.countryCode = value.value
      this.filters.Page = 1
      this.getData()
    },
    opt(data) {
      return dateTimeFormatString(data)
    },

    getData() {
      this.loading = true

      services
        .getCampaignsTransactions(this.organizationId, 'sms', this.filters)
        .then((resp) => {
          // services.getCampaignsTransactions('de07f552-21d6-4acc-ba04-805bc87c78ef', 'sms', this.filters).then((resp) => {
          const pagination = resp.data.data.pagination
          const dataList = resp.data.data.smsTransactions || []

          this.totalRegisters = pagination.totalRecords
          this.currentPage = pagination.currentPage
          this.totalPages = pagination.totalPages

          this.registers = dataList
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },

    updateData() {
      this.getData(this.requestOptions, this.propsHeaders)
    },

    handleDate(item) {
      return item ? dateTimeFormatString(item, null, null, false) : '-'
    },

    handleStatus(statusCode) {
      if (typeof statusCode != 'number') {
        return statusCode
      }

      const positions = {
        1: {
          status: 'text-success',
          label: this.$t('transational.logs.filters.delivered'),
        },
        2: {
          status: 'text-warning',
          label: this.$t('transational.logs.filters.pending'),
        },
        3: {
          status: 'text-danger',
          label: this.$t('transational.logs.filters.not-delivered'),
        },
      }

      return positions[statusCode] || positions.default
    },

    handlerValueTable(label, value) {
      if (label == 'sent') {
        return this.handleDate(value)
      }
      if (label == 'status') {
        return this.handleStatus(value)
      }
      return value
    },
  },
}
</script>

<style>
.dateInputCustom .form-control[readonly] {
  background-color: white !important;
}
.search-padding {
  padding-top: 23px;
}
</style>
